export const locale = {
  lang: 'da-DK',
  data: {},
};
